/**
 * Meddelande om hyreshöjning enligt 12 kap. 54 a § jordabalken.
 *
 * A letter with no numbered points and no signatures: the landlord exports
 * the PDF and sends it by registered post. Neither party signs.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Meddelande om hyreshöjning enligt 12 kap. 54 a § jordabalken';
const FORM_NUMBER = 'Formulär R-18';
export const villkorsandring54aV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'villkorsandring_54a',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Ändring av hyresvillkor',
        shortTitle: 'Hyreshöjning 54 a §',
        formNumber: FORM_NUMBER,
        statute: '12 kap. 54 a § jordabalken',
        signingMode: 'export_only',
        status: 'active',
        titleSuffix: { key: 'apartment_official_number', prefix: 'lgh' },
        preamble: 'Hyresvärdens meddelande till hyresgästen om begärd hyreshöjning enligt 12 kap. 54 a § jordabalken.',
        description: 'Används för att höja hyran för lägenhet utan förhandlingsklausul men där en förhandlingsordning gäller för huset (passivitetsregeln).\n\n' +
            'Snäv tillämpning men viktig: gäller endast bostadslägenhet som saknar förhandlingsklausul i hyresavtalet, men där det finns en förhandlingsordning för huset. Om hyresgästen inte skriftligen motsätter sig höjningen inom fristen (minst två månader från avsändandet) blir hen bunden av den nya hyran.\n\n' +
            'Signeras INTE — varken via Scrive eller för hand. Exportera PDF:en och skicka den med rekommenderad post till hyresgästen.',
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: false },
            { id: 'lessee', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: false },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
    },
    values,
    blocks: [
        {
            instanceId: 'letterhead',
            blockRef: 'common.letterhead@v1',
            slot: 'letterhead',
            input: { title: TITLE, form_number: FORM_NUMBER },
        },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'rubrik', blockRef: 'villkorsandring_54a.rubrik@v1', input: {} },
        { instanceId: 'uppgifter', blockRef: 'villkorsandring_54a.uppgifter@v1', input: {} },
        { instanceId: 'hyreshojning', blockRef: 'villkorsandring_54a.hyreshojning@v1', input: {} },
        { instanceId: 'kontakt', blockRef: 'villkorsandring_54a.kontakt@v1', input: {} },
    ],
});
//# sourceMappingURL=villkorsandring_54a.js.map